import React from 'react'
import { useTranslate } from 'src/localization/useTranslate'

/**
 * Plural translation component
 * @param pluralSource source string for count other than 1  e.g. (this is a string for 0 items)
 * @example
 * <PluralTrns
 *   pluralSource={'${count} transactions selected'} // ensure ${count} is the count variable
 *   singleSource={'1 transaction selected'}
 *   count={selectedTransactionsCount}
 * />
 * @param singleSource - assumes count is 1, does not have a ${count} variable
 * @param count - the count variable
 * @param expressions - other expressions that are not ${count}
 * @constructor
 */
const PluralTrns: React.FC<{
  pluralSource: string
  singleSource: string
  count: number
  expressions?: Record<string, string>
}> = ({ pluralSource, singleSource, count, expressions }) => {
  const translate = useTranslate()
  return (
    <>
      {count === 1
        ? translate(singleSource, expressions ?? {})
        : translate(pluralSource, {
            count: `${count}`,
            ...expressions,
          })}
    </>
  )
}

export default PluralTrns
